import React from 'react';
import clsx from 'clsx';
import { DialogContent, makeStyles } from '@material-ui/core';
import customClassName from '@configuratorware/configurator-frontendgui/App/Utils/customClassName';
import DefaultOptionsList from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Components/OptionsList';
import CustomDialog from '@configuratorware/configurator-frontendgui/Shared/Components/CustomDialog';
import NextComponentButton from './NextComponentButton';
import { useDispatch } from 'react-redux';
import { selectOptionclassification } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Actions';

const useStyles = makeStyles(
  (theme) => {
    return {
      dialogStyle: {
        height: '100%',
        [theme.breakpoints.down('sm')]: {
          width: '100%',
          maxWidth: '390px',
        },
        [theme.breakpoints.between('sm', 'xl')]: {
          width: '470px',
          maxWidth: '470px',
        },
        [theme.breakpoints.up('md')]: {
          marginLeft: '120px',
          '& .MuiBackdrop-root': {
            left: '140px',
          },
        },
      },
      [theme.breakpoints.between('sm', 'md')]: {
        [theme.orientation.portrait]: {
          top: '-110px !important',
        },
      },
      '& > div.MuiDialog-container': {
        [theme.breakpoints.between('sm', 'lg')]: {
          [theme.orientation.portrait]: {
            alignItems: 'flex-end',
          },
          [theme.orientation.landscape]: {
            alignItems: 'flex-start',
            marginTop: 35,
          },
        },
      },
      contentStyle: {},
      backDrop: {
        display: 'none',
      },
    };
  },
  {
    name: 'OptionsList',
  }
);

const OptionsList = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const onClose = () => {
    props.onClose();
    dispatch(selectOptionclassification({}));
  };
  return (
    <DefaultOptionsList
      {...props}
      classes={classes}
      render={({ classes, optionclassification, show, renderOptions }) => {
        return (
          <CustomDialog
            className={clsx(classes.dialogStyle, customClassName('options'))}
            dialogTitle={optionclassification.title}
            onCancel={onClose}
            onClose={onClose}
            open={show && !!optionclassification.identifier}
            BackdropProps={{
              classes: {
                root: classes.backDrop,
              },
            }}
          >
            <DialogContent className={classes.contentStyle}>
              {renderOptions()}
              <NextComponentButton />
            </DialogContent>
          </CustomDialog>
        );
      }}
    />
  );
};

export default OptionsList;
